import React from 'react';
import { styled, Typography } from '@mui/material';
import { CardComponent } from './CardComponent';
import { StyledColumnBox, StyledMediumTypography } from '../theme/StyledElements';

const StyledIndicatorBox = styled(StyledColumnBox)(() => ({
    marginTop: '10px',
    textAlign: 'center'
}));

interface StatisticsCardProps {
    statistics: string | number;
    title: string;
}

export function StatisticsCard({ statistics, title }: StatisticsCardProps): React.ReactElement {
    return (
        <CardComponent>
            <StyledIndicatorBox>
                <StyledMediumTypography variant="h1" color="#134C03">
                    {statistics}
                </StyledMediumTypography>
                <Typography variant="subtitle2" color="#134C03">
                    {title}
                </Typography>
            </StyledIndicatorBox>
        </CardComponent>
    );
}
